








































































import {Component, Vue, Emit} from 'vue-property-decorator';
import * as types from '@/mutation-types';
import API from '@/Api';
import {version} from '../../package.json';

@Component
export default class AppDrawer extends Vue {
    public drawer: boolean = true;
    public menus: any = null;
    public created() {
        window.eventBus.$on(types.APP_DRAWER_TOGGLED, () => this.drawer = !this.drawer);
        API.Instance
          .get('/api/menu')
          .then((response) => {
            this.menus = response.data;
          });
    }

    get getVersion() {
        return version;
    }
}
